import { Grid, Typography } from '@mui/material'
import s from './InfoItems.modules.scss'
import { useMemo } from 'react'

interface Item {
  label: string
  name: string | string[]
  labelSize?: number
  valueSize?: number
  render?: (item: Item) => React.JSX.Element
}

interface InfoItemsProps {
  items: Item[]
  itemsPerRow?: number
  title?: string
  itemsSpacing?: number
  actionComponents?: React.ReactNode
}

const InfoItems: React.FC<InfoItemsProps> = props => {
  const { items, itemsPerRow, title, actionComponents, itemsSpacing } = props

  const size = useMemo(() => (itemsPerRow ? 12 / itemsPerRow : 12), [itemsPerRow])

  return (
    <Grid container className={s.list}>
      {title && (
        <Grid item xs={12} style={{ marginBottom: '16px' }}>
          <Grid container>
            <Grid item xs={4}>
              <Typography
                variant="h6"
                style={{
                  whiteSpace: 'nowrap',
                  fontFamily: 'Ubuntu',
                  fontWeight: 500
                }}
                gutterBottom
              >
                {title}
              </Typography>
            </Grid>
            <Grid item xs={8} textAlign="right">
              {actionComponents}
            </Grid>
          </Grid>
        </Grid>
      )}
      <Grid item xs={12}>
        <Grid container spacing={itemsSpacing || 4}>
          {items.map((item: Item) => (
            <Grid item xs={size} key={item.label}>
              <Grid container>
                <Grid className={s.label} xs={item.labelSize ?? 4} item>
                  {item.label}
                </Grid>
                {Array.isArray(item.name) ? (
                  <div>
                    {item.name.map(inst => (
                      <div className={s.arrayValue}>{inst}</div>
                    ))}
                  </div>
                ) : (
                  <Grid className={s.value} xs={item.valueSize ?? 8} item title={item.name}>
                    {item?.render ? item.render(item) : item.name}
                  </Grid>
                )}
              </Grid>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Grid>
  )
}

export default InfoItems
